import type { ICatalog } from '@platform/core/types';
import type { IExpertSource } from './IExpertSource';

/** Модулі, з яких сторінка «Поради» бере поради експертів (прототип v4): «Експертні висновки», далі «База знань». */
export const EXPERT_MODULES: readonly string[] = ['expert', 'kb'];

/** Встановлені в робочому просторі модулі-джерела з головним типом запису, у порядку EXPERT_MODULES. Чиста функція. */
export function expertSourcesOf(catalog: ICatalog | undefined): IExpertSource[] {
  return EXPERT_MODULES.flatMap((key) => {
    const module = catalog?.modules.find((m) => m.key === key && m.installed);
    const rt = module ? (module.recordTypes.find((r) => r.main) ?? module.recordTypes[0])?.key : undefined;
    return module && rt ? [{ module, rt }] : [];
  });
}
